/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Jotkin API
 * LINE-driven calorie logging and dashboard API. This tool estimates calories for general wellness; it is not medical advice.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddPlanDishDto,
  AddPlanResultDto,
  AddPlanTextDto,
  ApplyPlanResultDto,
  FoodLogDto,
  PlanDto,
  PlanItemDto
} from '../model';

import { apiFetch } from '../../lib/api-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetPlanUrl = () => {




  return `/api/plan`
}

/**
 * One plan per user, with no date: it is what the user intends to eat, and nothing here counts toward a day until it is applied.
 * @summary The standing meal plan and where it lands against today
 */
export const getPlan = async ( options?: Parameters<typeof apiFetch>[1]): Promise<PlanDto> => {

  return apiFetch<PlanDto>(getGetPlanUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPlanQueryKey = () => {
    return [
    `/api/plan`
    ] as const;
    }


export const getGetPlanQueryOptions = <TData = Awaited<ReturnType<typeof getPlan>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlanQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlan>>> = ({ signal }) => getPlan({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlanQueryResult = NonNullable<Awaited<ReturnType<typeof getPlan>>>
export type GetPlanQueryError = unknown


export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlan>>,
          TError,
          Awaited<ReturnType<typeof getPlan>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlan>>,
          TError,
          Awaited<ReturnType<typeof getPlan>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The standing meal plan and where it lands against today
 */

export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlanQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAddPlanFromTextUrl = () => {




  return `/api/plan/items/text`
}

/**
 * Parsed and priced by the same recognizer and resolver as a LINE message, so one line may add several dishes. Items nothing could price come back in `rejected` rather than being dropped silently.
 * @summary Plan food by typing it
 */
export const addPlanFromText = async (addPlanTextDto: AddPlanTextDto, options?: Parameters<typeof apiFetch>[1]): Promise<AddPlanResultDto> => {

  return apiFetch<AddPlanResultDto>(getAddPlanFromTextUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addPlanTextDto)
  }
);}





export const getAddPlanFromTextMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPlanFromText>>, TError,{data: AddPlanTextDto}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addPlanFromText>>, TError,{data: AddPlanTextDto}, TContext> => {

const mutationKey = ['addPlanFromText'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addPlanFromText>>, {data: AddPlanTextDto}> = (props) => {
          const {data} = props ?? {};

          return  addPlanFromText(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddPlanFromTextMutationResult = NonNullable<Awaited<ReturnType<typeof addPlanFromText>>>
    export type AddPlanFromTextMutationBody = AddPlanTextDto
    export type AddPlanFromTextMutationError = void

    /**
 * @summary Plan food by typing it
 */
export const useAddPlanFromText = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPlanFromText>>, TError,{data: AddPlanTextDto}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addPlanFromText>>,
        TError,
        {data: AddPlanTextDto},
        TContext
      > => {
      return useMutation(getAddPlanFromTextMutationOptions(options), queryClient);
    }
    export const getAddPlanFromDishUrl = () => {




  return `/api/plan/items/dish`
}

/**
 * The dish comes from /api/dishes/search; priced exactly like a manual log.
 * @summary Plan a dish picked from the menu
 */
export const addPlanFromDish = async (addPlanDishDto: AddPlanDishDto, options?: Parameters<typeof apiFetch>[1]): Promise<PlanItemDto> => {

  return apiFetch<PlanItemDto>(getAddPlanFromDishUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addPlanDishDto)
  }
);}





export const getAddPlanFromDishMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPlanFromDish>>, TError,{data: AddPlanDishDto}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addPlanFromDish>>, TError,{data: AddPlanDishDto}, TContext> => {

const mutationKey = ['addPlanFromDish'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addPlanFromDish>>, {data: AddPlanDishDto}> = (props) => {
          const {data} = props ?? {};

          return  addPlanFromDish(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddPlanFromDishMutationResult = NonNullable<Awaited<ReturnType<typeof addPlanFromDish>>>
    export type AddPlanFromDishMutationBody = AddPlanDishDto
    export type AddPlanFromDishMutationError = void

    /**
 * @summary Plan a dish picked from the menu
 */
export const useAddPlanFromDish = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPlanFromDish>>, TError,{data: AddPlanDishDto}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addPlanFromDish>>,
        TError,
        {data: AddPlanDishDto},
        TContext
      > => {
      return useMutation(getAddPlanFromDishMutationOptions(options), queryClient);
    }
    export const getApplyPlanUrl = () => {




  return `/api/plan/apply`
}

/**
 * Already-applied items are skipped, so tapping twice cannot double-log a meal.
 * @summary Log every item still planned
 */
export const applyPlan = async ( options?: Parameters<typeof apiFetch>[1]): Promise<ApplyPlanResultDto> => {

  return apiFetch<ApplyPlanResultDto>(getApplyPlanUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getApplyPlanMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyPlan>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof applyPlan>>, TError,void, TContext> => {

const mutationKey = ['applyPlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyPlan>>, void> = () => {


          return  applyPlan(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApplyPlanMutationResult = NonNullable<Awaited<ReturnType<typeof applyPlan>>>

    export type ApplyPlanMutationError = unknown

    /**
 * @summary Log every item still planned
 */
export const useApplyPlan = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyPlan>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof applyPlan>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getApplyPlanMutationOptions(options), queryClient);
    }
    export const getApplyPlanItemUrl = (id: string,) => {




  return `/api/plan/items/${id}/apply`
}

/**
 * The item keeps its place in the plan, marked as applied.
 * @summary Log one planned item as eaten
 */
export const applyPlanItem = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<FoodLogDto> => {

  return apiFetch<FoodLogDto>(getApplyPlanItemUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getApplyPlanItemMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyPlanItem>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof applyPlanItem>>, TError,{id: string}, TContext> => {

const mutationKey = ['applyPlanItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyPlanItem>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  applyPlanItem(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApplyPlanItemMutationResult = NonNullable<Awaited<ReturnType<typeof applyPlanItem>>>

    export type ApplyPlanItemMutationError = void

    /**
 * @summary Log one planned item as eaten
 */
export const useApplyPlanItem = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyPlanItem>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof applyPlanItem>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getApplyPlanItemMutationOptions(options), queryClient);
    }
    export const getUnapplyPlanItemUrl = (id: string,) => {




  return `/api/plan/items/${id}/apply`
}

/**
 * For eating the same plan another day. The food log it produced is left alone — this un-plans, it does not un-eat.
 * @summary Mark an applied item as planned again
 */
export const unapplyPlanItem = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getUnapplyPlanItemUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnapplyPlanItemMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unapplyPlanItem>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unapplyPlanItem>>, TError,{id: string}, TContext> => {

const mutationKey = ['unapplyPlanItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unapplyPlanItem>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  unapplyPlanItem(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnapplyPlanItemMutationResult = NonNullable<Awaited<ReturnType<typeof unapplyPlanItem>>>

    export type UnapplyPlanItemMutationError = void

    /**
 * @summary Mark an applied item as planned again
 */
export const useUnapplyPlanItem = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unapplyPlanItem>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unapplyPlanItem>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getUnapplyPlanItemMutationOptions(options), queryClient);
    }
    export const getRemovePlanItemUrl = (id: string,) => {




  return `/api/plan/items/${id}`
}

/**
 * If it had been applied, the food log stays; only the plan entry goes.
 * @summary Drop an item from the plan
 */
export const removePlanItem = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getRemovePlanItemUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemovePlanItemMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removePlanItem>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removePlanItem>>, TError,{id: string}, TContext> => {

const mutationKey = ['removePlanItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removePlanItem>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  removePlanItem(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemovePlanItemMutationResult = NonNullable<Awaited<ReturnType<typeof removePlanItem>>>

    export type RemovePlanItemMutationError = void

    /**
 * @summary Drop an item from the plan
 */
export const useRemovePlanItem = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removePlanItem>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removePlanItem>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRemovePlanItemMutationOptions(options), queryClient);
    }
